interface LevelIconProps {
  level: 'beginner' | 'intermediate' | 'advanced' | 'expert' | null | undefined
  size?: number
}

const levelSteps: Record<string, number> = {
  beginner: 1,
  intermediate: 2,
  advanced: 3,
  expert: 4,
}

const levelLabels: Record<string, string> = {
  beginner: 'Iniciante',
  intermediate: 'Intermediário',
  advanced: 'Avançado',
  expert: 'Expert',
}

export function LevelIcon({ level, size = 20 }: LevelIconProps) {
  const active = level ? (levelSteps[level] ?? 0) : 0
  const label = level ? (levelLabels[level] ?? level) : '—'

  const bars = [1, 2, 3, 4]
  const barWidth = Math.round(size * 0.18)
  const gap = Math.round(size * 0.08)
  const maxHeight = size

  return (
    <span
      title={label}
      style={{
        display: 'inline-flex',
        alignItems: 'flex-end',
        gap,
        height: maxHeight,
        verticalAlign: 'middle',
        transform: 'translateY(-2px)',
      }}
    >
      {bars.map((step) => {
        const height = Math.round((maxHeight / 4) * step)
        const isActive = step <= active
        return (
          <span
            key={step}
            style={{
              width: barWidth,
              height,
              borderRadius: 3,
              backgroundColor: isActive ? '#f97316' : '#6b7280',
              display: 'inline-block',
            }}
          />
        )
      })}
    </span>
  )
}
